/* @flow */

import { type AxiosPromise } from 'axios';
import xhr from '../utils/xhr';

import { type Usuario, type Contato } from './types';

const buscarContatos = (usuario: Usuario): AxiosPromise<Contato[]> => xhr.get(usuario.contatosUrl);

export default buscarContatos;
